import { useState } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import '../../styles/Pages.css';

const COMMITTEES = [
    { name: 'Management, Development and Planning', slug: 'management-development-planning' },
    { name: 'Board of Student Development', slug: 'student-welfare-committee' },
    { name: 'Competitive Examination Guidance Center', slug: 'competitive-exam-guidance-center' },
    { name: 'Science Association', slug: 'science-committee' },
    { name: 'Cultural Events Committee', slug: 'cultural-events-committee' },
    { name: 'Scholarship Committee', slug: 'scholarship-committee' },
    { name: 'Library Committee', slug: 'library-committee' },
    { name: 'Discipline Committee', slug: 'discipline-committee' },
    { name: 'Sports Committee', slug: 'sports-committee' },
    { name: 'Women Empowerment Cell', slug: 'female-students-personality-development-committee' },
    { name: 'Anti Ragging Committee', slug: 'anti-ragging-committee' },
    { name: 'Student Counselling', slug: 'student-counselling' },
    { name: 'Annual Magazine Committee', slug: 'magazine-committee' },
    { name: 'Parents Meet', slug: 'parents-rally' },
    { name: 'Botanical Garden Development Committee', slug: 'botany-udayana-development' },
    { name: 'Health Committee', slug: 'health-rally' },
    { name: 'Educational Tour Committee', slug: 'picnic-planning' },
    { name: 'Soft Skills Development Committee', slug: 'soft-skills-development-committee' },
    { name: 'Book Lover Club', slug: 'book-lover-club' },
    { name: 'Environment Awareness Committee', slug: 'environment-aware-awareness' },
    { name: 'Publicity Committee', slug: 'publicity-committee' },
    { name: 'Welcome Committee', slug: 'welcome-committee' },
    { name: 'Premises Development and Decoration', slug: 'premises-development-decoration' },
    { name: 'Rangoli Committee', slug: 'rangoli-committee' },
    { name: 'Sound & Video Shooting Committee', slug: 'sound-video-shooting-committee' },
    { name: 'Stage Decoration Committee', slug: 'stage-decoration-committee' },
    { name: 'Board of Extra-Mural Studies', slug: 'board-of-extra-mural-studies' },
    { name: 'Slow & Advanced Learner', slug: 'slow-advanced-lerner' },
    { name: 'Research Allocation', slug: 'research-allocation' },
    { name: 'Mentor/Mentee Program', slug: 'mentor-mentee-program' },
    { name: 'Women Sexual Harassment Committee', slug: 'women-sexual-harassment-committee' },
    { name: 'Certificate Course Committee', slug: 'certificate-course-committee' },
    { name: 'Equal Opportunity Cell', slug: 'equal-opportunity-cell' },
];

function CommitteesPage() {
    const [active, setActive] = useState(COMMITTEES[0].slug);
    const current = COMMITTEES.find(c => c.slug === active);

    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Committees</p>
                <h1>Committees</h1>
                <p>All {COMMITTEES.length} committees of Shri Mulikadevi Mahavidyalaya, Nighoj.</p>
            </div>
            <div className="page-content">
                <div className="committees-layout">
                    {/* Sidebar list */}
                    <div className="info-card" style={{ padding: '1rem 0', position: 'sticky', top: '80px' }}>
                        <h2 style={{ padding: '0 1rem 0.5rem' }}>All Committees</h2>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0, maxHeight: '70vh', overflowY: 'auto' }}>
                            {COMMITTEES.map(c => (
                                <li key={c.slug}>
                                    <button
                                        onClick={() => setActive(c.slug)}
                                        style={{
                                            display: 'block', width: '100%', textAlign: 'left',
                                            padding: '0.6rem 1rem', border: 'none', cursor: 'pointer', fontSize: '0.85rem',
                                            background: active === c.slug ? 'linear-gradient(90deg,#2d6a4f22,transparent)' : 'transparent',
                                            borderLeft: active === c.slug ? '3px solid #2d6a4f' : '3px solid transparent',
                                            color: active === c.slug ? '#2d6a4f' : '#444',
                                            fontWeight: active === c.slug ? 700 : 400,
                                            transition: 'all 0.15s',
                                        }}
                                    >
                                        {c.name}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Main panel */}
                    <div>
                        <div className="info-card">
                            <h2>{current.name}</h2>
                            <p style={{ color: '#666', marginBottom: '1rem' }}>
                                The <strong>{current.name}</strong> is one of the active committees at Shri Mulikadevi Mahavidyalaya, Nighoj.
                                This committee is responsible for planning, coordinating, and executing activities related to its mandate as defined by college administration and the Governing Council.
                            </p>
                            <p style={{ color: '#555', fontSize: '0.9rem' }}>
                                📌 <em>Member details are managed by the college admin and will be updated here.
                                    For the latest committee composition, contact the college office at{' '}
                                    <a href="mailto:ascnighoj@gmail.com" style={{ color: '#2d6a4f' }}>ascnighoj@gmail.com</a> or call (02488) 230438.</em>
                            </p>
                        </div>
                        <div className="info-card" style={{ marginTop: '1rem' }}>
                            <h2>Objectives</h2>
                            <ul>
                                <li>To systematically plan and execute activities within its domain.</li>
                                <li>To coordinate with students, faculty, and management for smooth functioning.</li>
                                <li>To maintain records and submit reports to the Principal.</li>
                                <li>To ensure student welfare, safety, and development through its activities.</li>
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Mobile: grid of all committees */}
                <div style={{ marginTop: '2rem' }}>
                    <h2 style={{ color: '#1a3c5e', marginBottom: '1rem' }}>All Committees at a Glance</h2>
                    <div className="cards-grid">
                        {COMMITTEES.map((c, i) => (
                            <div
                                className="grid-card"
                                key={c.slug}
                                style={{ cursor: 'pointer' }}
                                onClick={() => { setActive(c.slug); window.scrollTo({ top: 200, behavior: 'smooth' }); }}
                            >
                                <h3>Committee {i + 1}</h3>
                                <p style={{ fontWeight: 600, color: '#2d6a4f' }}>{c.name}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default CommitteesPage;
